export default "__VITE_ASSET__vc6wDUVo__"